export const projectStatus = { active: 'Active', completed: 'Completed',inactive: 'Inactive' }

export const projectStatusArray =  Object.keys(projectStatus).map(value => ({
  value,
  label: projectStatus[value]
}))